// Custom scrollbar styles for CodeEditorPanel
export const codeEditorScrollbarStyles = `
  /* WebKit browsers (Chrome, Safari, Edge) */
  .code-editor-scrollbar::-webkit-scrollbar {
    width: 8px;
  }

  .code-editor-scrollbar::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }

  .code-editor-scrollbar::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    transition: all 0.2s ease;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  .code-editor-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.25);
  }

  /* Dark mode */
  .dark .code-editor-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.15);
  }

  .dark .code-editor-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.25);
  }

  /* Firefox */
  .code-editor-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
  }

  .dark .code-editor-scrollbar {
    scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
  }

  /* Smooth scrolling */
  .code-editor-scrollbar {
    scroll-behavior: smooth;
  }

  /* Hide scrollbar when not needed */
  .code-editor-scrollbar:not(:hover)::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.08);
  }

  .dark .code-editor-scrollbar:not(:hover)::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.08);
  }

  /* Ultra-thin scrollbar on hover for more Apple-like feel */
  .code-editor-scrollbar:hover::-webkit-scrollbar {
    width: 10px;
  }

  /* File explorer scrollbar - more compact */
  .file-explorer-scrollbar::-webkit-scrollbar {
    width: 6px;
  }

  .file-explorer-scrollbar::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 3px;
  }

  .file-explorer-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.12);
    border-radius: 3px;
    transition: all 0.2s ease;
  }

  .file-explorer-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  .dark .file-explorer-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.12);
  }

  .dark .file-explorer-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .file-explorer-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.12) transparent;
  }

  .dark .file-explorer-scrollbar {
    scrollbar-color: rgba(255, 255, 255, 0.12) transparent;
  }

  /* Tabs scrollbar - ultra-compact */
  .tabs-scrollbar::-webkit-scrollbar {
    height: 4px;
  }

  .tabs-scrollbar::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 2px;
  }

  .tabs-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    transition: all 0.2s ease;
  }

  .tabs-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.18);
  }

  .dark .tabs-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .dark .tabs-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.18);
  }

  .tabs-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.1) transparent;
  }

  .dark .tabs-scrollbar {
    scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
  }

  /* Code content scrollbar - special styling for code area */
  .code-content-scrollbar::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .code-content-scrollbar::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }

  .code-content-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.18);
    border-radius: 4px;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    background-clip: content-box;
  }

  .code-content-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.28);
  }

  .code-content-scrollbar::-webkit-scrollbar-corner {
    background: transparent;
  }

  .dark .code-content-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.18);
  }

  .dark .code-content-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.28);
  }

  .code-content-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
  }

  .dark .code-content-scrollbar {
    scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
  }
`;

// Inject styles into the document head
export const injectCodeEditorScrollbarStyles = () => {
  if (typeof document !== "undefined") {
    const existingStyle = document.getElementById(
      "code-editor-scrollbar-styles",
    );
    if (!existingStyle) {
      const style = document.createElement("style");
      style.id = "code-editor-scrollbar-styles";
      style.textContent = codeEditorScrollbarStyles;
      document.head.appendChild(style);
    }
  }
};
